import { IconButton } from "@material-ui/core";
import React, { forwardRef } from "react";
import styled from "styled-components";
import ZohoIcon from "../../../../assets/images/iconos/zoho.png";
import { prepareZohoUrl } from "./prepareZohoUrl";
import { TZohoModule } from "./ViewInZohoButton";

const StyledLink = styled.a`
  color: inherit;
  text-decoration: none;
`;

const StyledButton = styled(IconButton)`
  text-transform: none;
  font-weight: 400;
  font-size: 0.75rem;
  padding: 0.375rem;
  transition: background 0.1s ease-out 0s, box-shadow 0.15s ease-out 0s;

  &:hover,
  &:focus {
    background-color: rgba(9, 30, 66, 0.1);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.07);
  }
`;

const StyledZohoIcon = styled.img`
  height: 1.125rem;
  width: 1.125rem;
`;

interface IViewInZohoIconButtonProps {
  zohoModule: TZohoModule;
  zohoId: string;
}

const ViewInZohoIconButton = forwardRef(
  (props: IViewInZohoIconButtonProps, ref) => {
    const { zohoModule, zohoId } = props;

    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
    };

    const url = prepareZohoUrl(zohoModule, zohoId);

    return (
      <StyledLink
        ref={ref as any}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
      >
        <StyledButton className="CMuiViewInZohoIconButton">
          <StyledZohoIcon src={ZohoIcon} alt="" />
        </StyledButton>
      </StyledLink>
    );
  }
);

export default ViewInZohoIconButton;
